export const items = () => {
  return {
    query: `query($vehicleId: String) {
      instructionSheet {
        items(vehicleId: $vehicleId) {
          objectId
          title
          subTitle
          coverImage {
            fileId
            url
            width
            height
          }
        }
      }
    }`
  }
}

export const itemDetail = () => {
  return {
    query: `query($instructionId: String!) {
      instructionSheet {
        itemDetail(instructionId: $instructionId) {
          objectId
          title
          subTitle
          youzanGotoUrl
          taobaoGotoUrl
          vehicles {
            objectId
            brand {
              objectId
              name
              logo {
                fileId
                url
                width
                height
              }
              displayOrder
            }
            series
            category
            image {
              fileId
              url
              width
              height
            }
            displayOrder
          }
          applied
          link
          tips
          coverImage {
            fileId
            url
            width
            height
          }
          video
          steps
          displayOrder
          vehiclesFormatted
          isPublished
        }
      }
    }`
  }
}

export const selectVehicle = () => {
  return {
    query: `query {
      gigaWorkShop {
        selectVehicle {
          brand {
            name
            objectId
          }
          vehicles {
            objectId
            brand {
              objectId
              name
              displayOrder
            }
            series
            category
            image {
              fileId
              url
              width
              height
            }
            displayOrder
          }
        }
      }
    }`
  }
}

export const search = () => {
  return {
    query: `query($keyword: String!) {
      instructionSheet {
        search(keyword: $keyword) {
          objectId
          title
          subTitle
          coverImage {
            fileId
            url
            width
            height
          }
        }
      }
    }`
  }
}


// WEBPACK FOOTER //
// ./src/http/query.js